import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth';

/**
 * Change which business the app is looking at, and go to its dashboard.
 *
 * ── WHY IT IS A HOOK AND NOT THREE LINES WHERE IT IS NEEDED ──
 * The switch has a step that is easy to forget and invisible when forgotten:
 * every cached query is keyed to the PREVIOUS org, so without clearing the
 * cache the new tenant's name sits above the old tenant's invoices until each
 * key happens to refetch. The sidebar switcher had the clear; the Clients
 * page's "Open" link did not, and the Overview's rows would have been a third
 * place to get it wrong. One hook, one place the rule lives.
 *
 * The destination is the dashboard unless the caller names one - never "stay
 * where you are": the page you were on was about the old business, and a URL
 * like /invoices/<id> names a record the new one does not have. The Clients
 * page names /review, because that is what it opened the business for.
 */
export function useSwitchOrg() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const setActiveOrg = useAuthStore((s) => s.setActiveOrg);

  return (orgId: string, to: string = '/') => {
    setActiveOrg(orgId);
    queryClient.clear();
    navigate(to);
  };
}
